import React from "react";
import styles from "./partners.css";
import PartnersConf from "./PartnersConf";
import { FormattedMessage } from "react-intl";

export const Partners = () => {
  return (
    <div className={styles.container} id="partners">
      <h2 className={styles.heading}>
        <FormattedMessage
          id="Clients.title"
          defaultMessage="Who have we work with"
        />
      </h2>
      <ul className={styles.partnerList}>
        {PartnersConf.clients.map((partner, i) => {
          return (
            <li key={i}>
              <a
                className={styles.partnerItemImage + " grayscale"}
                href={partner.href}
                target="_blank"
                key={partner.href}
                style={{
                  backgroundImage:
                    "url(" +
                    process.env.REACT_APP_MEDIA_CONTENT +
                    "logos/" +
                    partner.logo +
                    ")"
                }}
              >
                {partner.title}
              </a>
            </li>
          );
        })}
      </ul>
      <h2 className={styles.heading}>
        <FormattedMessage id="Partners.title" defaultMessage="Our partners" />
      </h2>
      <ul className={styles.partnerList}>
        {PartnersConf.partners.map((partner, i) => {
          return (
            <li key={i}>
              <a
                className={styles.partnerItemImage + " grayscale"}
                href={partner.href}
                target="_blank"
                key={partner.href}
                style={{
                  backgroundImage:
                    "url(" +
                    process.env.REACT_APP_MEDIA_CONTENT +
                    "logos/" +
                    partner.logo +
                    ")"
                }}
              >
                {partner.title}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Partners;



// WEBPACK FOOTER //
// ./src/containers/partners/Partners.js